import { getLocale } from "../runtime";

const sv_atcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Austria`
};

const atcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_atcountryenglish(inputs)
	return "atCountryEnglish";
};

export { atcountryenglish as "atCountryEnglish" };